import { QueryClient, type UseInfiniteQueryResult } from '@tanstack/react-query'

const queryClientConfig = {
	defaultOptions: {
		queries: {
			networkMode: 'online',
			retry: typeof window === 'undefined' ? 0 : 1,
			retryOnMount: true,
			retryDelay: 1000,
			staleTime: 600_000, //10 min
			refetchOnMount: true,
			refetchOnWindowFocus: false,
			refetchOnReconnect: true
		}
	}
} satisfies ConstructorParameters<typeof QueryClient>[0]

export function createAppQueryClient() {
	return new QueryClient(queryClientConfig)
}

export const infiniteQueryFetchNextPage = async (
	infiniteQuery: UseInfiniteQueryResult
) => {
	if (infiniteQuery.hasNextPage && !infiniteQuery.isFetching) {
		await infiniteQuery.fetchNextPage()
	}
}
